// src/pages/admin/AdminLeads.js
// Maxula
import React, { useEffect, useState } from 'react';
import { leadAPI } from '../../services/api';

const STATUS = { new: 'bg-blue-100 text-blue-700', contacted: 'bg-yellow-100 text-yellow-700', closed: 'bg-gray-100 text-gray-600' };

const AdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { try { const res = await leadAPI.adminList(); setLeads(res.data?.data || []); } catch (e) {} finally { setLoading(false); } })(); }, []);

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Leads (contacts clients)</h1>
      {loading ? <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600" /></div> : (
        <div className="overflow-x-auto bg-white rounded-xl border border-gray-200">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-gray-600"><tr>
              <th className="px-4 py-3 text-left">Client</th><th className="px-4 py-3 text-left">Marchand</th>
              <th className="px-4 py-3 text-left">Offre</th><th className="px-4 py-3 text-left">Contact</th>
              <th className="px-4 py-3 text-center">Statut</th><th className="px-4 py-3 text-left">Date</th>
            </tr></thead>
            <tbody className="divide-y divide-gray-100">
              {leads.map((l) => (
                <tr key={l._id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{l.name}</td>
                  <td className="px-4 py-3">{l.merchantId?.businessName || '—'}</td>
                  <td className="px-4 py-3">{l.dealTitle || '—'}</td>
                  <td className="px-4 py-3 text-gray-500">{l.phone} {l.email}</td>
                  <td className="px-4 py-3 text-center"><span className={`text-xs px-2 py-0.5 rounded-full ${STATUS[l.status]}`}>{l.status}</span></td>
                  <td className="px-4 py-3 text-gray-500">{new Date(l.createdAt).toLocaleDateString('fr-FR')}</td>
                </tr>
              ))}
              {leads.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-gray-400">Aucun lead.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminLeads;
